<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X0c3nw/tc-custom/9781459207967.jpg?1705766125052" alt="This image is the cover for the book One Night, Two Heirs, Texas Cattleman's Club: The Showdown"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">One Night, Two Heirs, Texas Cattleman's Club: The Showdown
      </h1>
      <p class="bookDescription body article font2">
        <b><i>USA Today</i>–Bestselling Author: He gave her twins—but can he give her true love?</b><br/><br/>Duty is everything to marine Rick Pruitt. And upon seeing Sadie Price with twin girls, he realizes he has some proposing to do. He never would have left Royal, Texas, if he’d known Sadie was carrying his babies.<br/><br/>Yet the feisty single mom has no intention of agreeing to a loveless marriage. True, she and Rick share a bond, as well as undeniable passion. But Sadie believes vows should last a lifetime, not be declared out of obligation—making it Rick’s new mission to change her mind. . . . <br/><br/>“[Maureen Child] has a remarkable talent for unusual, poignant plots and captivating characters.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maureen Child
      </h2>
      
      <p class="authorDescription body article">Maureen Child is the author of more than 130 romance novels and novellas that routinely appear on bestseller lists and have won numerous awards, including the National Reader&#39;s Choice Award. A&#160;seven-time nominee for the prestigous RITA award from Romance Writers of America, one of her books was made into a CBS-TV movie called THE SOUL COLLECTER.&#160;&#160;Maureen recently moved from&#160;California to the mountains of Utah and is trying to get used to snow.&#160;&#160;&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9231226a